import { useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from '../../routes/routeConstants/apiRoutes';

const CompanyService = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const [companyImageUrl, setCompanyImageUrl] = useState<string>();

  const fetchCompanyImage = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(ApiRoutes.COMPANY_IMAGE);
      const url = response.data.url;
      setCompanyImageUrl(url);
    } catch (error) {
      console.log('Error is ', error);
      setCompanyImageUrl(undefined);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchCompanyImage,
    companyImageUrl,
    setCompanyImageUrl,
  };
};

export default CompanyService;
